import styled from 'styled-components';

import {Hint} from 'components/ui-kit/Hint';

import {colors} from '../../../../../theme';

export const FooterContainer = styled.div`
    display: grid;
    gap: 12px;
    grid-template-columns: 1fr 1fr;
`;

export const BalanceContainer = styled.div`
    margin-bottom: 10px;
`;

export const FormContainer = styled.div``;

export const FormFields = styled.div`
    display: grid;
    grid-row-gap: 10px;
    grid-column-gap: 30px;
    margin-bottom: 20px;
    overflow: hidden;
`;

export const Field = styled(Hint)`
    display: flex;
    flex-flow: column wrap;

    > span {
        font-size: 12px;
        color: ${colors.textSecondary};
        padding-bottom: 6px;
        margin-top: 2px;
    }
`;
